<!-- Copyright: Seán I. O'Donoghue -->

<!-- In the phone menu (Primary/Dialog.vue), left-aligned since 2026-10-14: "Archive" on the left
     of its line, the years newest first, row by row from the left. -->
<template>
  <fieldset>
    <legend>Archive</legend>
    <menu>
      <PrimaryItem
        v-for="year in years"
        :key="`navPrim-${year}`"
        :to="year"
        :selected="year === selected"
      >{{ year }}</PrimaryItem
      >
    </menu>
  </fieldset>
</template>

<script setup>
const log = (msg) => process.env.VUE_APP_DEV && console.log(); // eslint-disable-line
// eslint-disable-next-line
const props = defineProps({
  years: {default: []},
  selected: {default: ""}
});
import PrimaryItem from "@/components/Navigation/Primary/Item.vue";
</script>

<style scoped>
/* * {
  background-color: rgb(0 100 0 / 0.1) !important;
} */
fieldset {
  height: 100%;
  min-width: 0; /* prevents from overflowing */
  padding: 0;
  margin: 0.3rem 0 0.6rem 0;
  border: 1px solid transparent;
  border-top-color: var(--primary-navigation-color);
  font-weight: 600;
}
.lightMode fieldset {
  border-top-color: var(--text-color-less-subtle);
}
legend {
  color: var(--primary-navigation-color);
  margin: 0; /* on the left of its line */
  padding: 0 12px 0 0;
}
.lightMode legend {
  color: var(--text-color-less-subtle);
}
menu {
  height: 100%;
  width: auto;
  display: grid;
  grid-template-columns: repeat(4, auto);
  justify-content: space-between; /* space-evenly */
  grid-template-rows: repeat(auto-fit, minmax(0, 1fr)); /* Evenly space rows vertically */
  grid-auto-rows: minmax(0, 1fr);
  /* auto not 1fr: https://stackoverflow.com/q/70770416*/
  /* grid-auto-rows: min-content; */
  /* row-gap: 1.4rem; */
  /* row-gap: 18%; */
  padding: 0;
  margin-top: 1rem;
  font-weight: 700;
}
menu :deep(li) {
  text-align: left; /* Item.vue right-aligns */
}
menu :deep(a) {
  color: var(--primary-navigation-color); /* override default link color */
}
.lightMode menu :deep(a) {
  color: var(--text-color-less-subtle);
  text-shadow: none;
}
/* menu :deep(a:focus), */
menu :deep(a:hover) {
  color: var(--primary-navigation-color); /* clobber default link color */
  background-color: var(--focus-background-color);
  border-radius: 0.4rem;
}
</style>
